import { render, staticRenderFns } from "./request-detail.vue?vue&type=template&id=2f1defae&scoped=true&"
import script from "./request-detail.vue?vue&type=script&lang=js&"
export * from "./request-detail.vue?vue&type=script&lang=js&"
import style0 from "./request-detail.vue?vue&type=style&index=0&id=2f1defae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1defae",
  null
  
)

export default component.exports